import React from "react";
import { esHtml, prepararHtml, parsearTextoClinico } from "./formatoClinico";
import "./TextoClinico.scss";

/**
 * Pinta un texto clinico (descripcion, guia, contraindicaciones, guion de una
 * terapia) respetando parrafos, saltos de linea y un marcado minimo. Ver
 * formatoClinico.js para el por que.
 *
 * Todo lo que no es HTML se entrega a React como TEXTO, que lo escapa: no hay
 * superficie que atacar en ese camino. El HTML solo entra por
 * dangerouslySetInnerHTML despues de pasar por sanearHtml().
 *
 * @param {string}  valor       el texto tal y como viene de la API
 * @param {string}  [className] clases extra sobre el contenedor
 * @param {node}    [vacio]     que pintar cuando no hay texto (null por defecto)
 */
function pintarInline(partes, clavePadre) {
  return partes.map((parte, i) => {
    const clave = `${clavePadre}-${i}`;
    if (parte.tipo === "negrita")
      return <strong key={clave}>{parte.valor}</strong>;
    if (parte.tipo === "cursiva") return <em key={clave}>{parte.valor}</em>;
    return <React.Fragment key={clave}>{parte.valor}</React.Fragment>;
  });
}

export function TextoClinico({ valor, className = "", vacio = null }) {
  const texto = String(valor ?? "").trim();
  if (!texto) return vacio;

  const clases = `texto-clinico${className ? ` ${className}` : ""}`;

  if (esHtml(texto)) {
    return (
      <div
        className={`${clases} texto-clinico--html`}
        dangerouslySetInnerHTML={{ __html: prepararHtml(texto) }}
      />
    );
  }

  const bloques = parsearTextoClinico(texto);

  return (
    <div className={clases}>
      {bloques.map((bloque, i) => {
        const claveBloque = `b${i}`;

        if (bloque.tipo === "lista") {
          const Lista = bloque.ordenada ? "ol" : "ul";
          return (
            <Lista key={claveBloque}>
              {bloque.items.map((item, j) => (
                <li key={`${claveBloque}-${j}`}>
                  {pintarInline(item, `${claveBloque}-${j}`)}
                </li>
              ))}
            </Lista>
          );
        }

        return (
          <p key={claveBloque}>
            {bloque.lineas.map((linea, j) => (
              <React.Fragment key={`${claveBloque}-${j}`}>
                {j > 0 ? <br /> : null}
                {pintarInline(linea, `${claveBloque}-${j}`)}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}

export default TextoClinico;
